<template>
    <div class="d-flex flex-column fill-height"  id="p_top_purchases">
        <v-row ref="headerFilters" class="flex-grow-0">
            <data-table-filters  v-if="!isMobile"
                :name="tb('Estatísticas - Top Compras')"
                :has-active-filters="hasActiveFilters"
                :filters="filters"
                :schema="tSchema(schema)"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh"
                @clear-filters="onClearFilters()"
                @view-type-changed="changeViewType($event)"
                :yearsList="schema && schema.homologous_period ? schema.homologous_period.items : undefined"
                showGraphTypeSelection
                :topPurchasesViewType="currentView"
                :changeViewTypeEnabled="changeViewTypeEnabled"
            >
            </data-table-filters>
            <div class="col wrap-title-filters" v-else >
                <filters-dialog
                    :isMonthlyPurchases="true"
                    :name="tb('Estatísticas - Top Compras')"
                    :has-active-filters="hasActiveFilters"
                    :filters="filters"
                    :schema="tSchema(schema)"
                    :has-expanded-active-filters="hasExpandedActiveFilters"
                    @expand-active-filters="hasExpandedActiveFilters = $event"
                    @remove-filter="removeFilter"
                    @refresh="refresh"
                    @clear-filters="onClearFilters()"
                    @view-type-changed="changeViewType($event)"
                    :yearsList="schema && schema.homologous_period ? schema.homologous_period.items : undefined"
                    showGraphTypeSelection
                    :topPurchasesViewType="currentView"
                    :changeViewTypeEnabled="changeViewTypeEnabled"
                    >
                </filters-dialog>
            </div>
        </v-row>

        <v-row class="flex-grow-1">
            <v-col v-if="displayItems && displayItems.length>0 && isMobile">
                <v-card elevation="2" :class="'wrap-total top-purchases'"
                                    >
                                    <v-row>
                                        <v-col class="d-flex flex-column col pt-0 pb-0">
                                            <v-row class="d-flex align-start pt-0 pb-0">
                                                <v-col class="col col-4 px-0 pt-0 pb-0 wrap-l">
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" >{{ tb('TOTAIS') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" >{{ tb('VALOR') }} </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="displayItems[currentItemDisplay].total_sum_minus_one">{{ tb('VALOR (N-1)') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="displayItems[currentItemDisplay].total_sum_minus_two">{{ tb('VALOR (N-2)') }}</v-col>
                                                </v-col>
                                                <v-col class="col col-8  pt-0 pb-0 wrap-r">
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" >
                                                        <div class="empty" >
                                                        </div>

                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                        <div class="datatable-designation-text" >
                                                            <span v-html="'<b>'+formatPrice(displayItems[currentItemDisplay].total_sum)+'</b>'"></span>
                                                        </div>
                                                    </v-col>

                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="displayItems[currentItemDisplay].total_sum_minus_one">
                                                        <div  class="datatable-multi-line-text">
                                                            <span v-html="'<b>'+formatPrice(displayItems[currentItemDisplay].total_sum_minus_one)+'</b>'"></span>
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="displayItems[currentItemDisplay].total_sum_minus_two" >
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            <div  class="datatable-multi-line-text">
                                                            <span v-html="'<b>'+formatPrice(displayItems[currentItemDisplay].total_sum_minus_two)+'</b>'"></span>
                                                        </div>
                                                        </div>
                                                    </v-col>

                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                </v-card>
            </v-col>
            <v-col>
                <pure-datatable endpoint="/api/statistics/top-purchases" v-show="currentView == 'table'" @data-changed="onDataChanges" :queryParams="queryParams" :ready="ready" ref="datatable" v-slot:default="{ vOn, vBind, isLoading }">
                    <div>
                        <portal to="v-form-base">
                            <v-form-base :model="filters" :schema="tSchema(schema)" @input="onFiltersChanged"> </v-form-base>
                        </portal>

                        <v-data-table id="top_purchases"
                            class="elevation-1 d-flex flex-column justify-space-between no-extra-padding-data-table"
                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                            fixed-header
                            multi-sort
                            @update:options="refresh"
                            :items="displayItems"
                            :headers="tHeaders(headers)"
                            :header-props="headerProps"
                            :hide-default-headers="isMobile"
                            v-on="vOn"
                            v-bind="vBind"
                            hide-default-footer
                            :no-data-text="$t('table.noData')"
                            :no-results-text="$t('table.noResults')"
                            :group-by="'branch_identifier'"
                            :loading="isMobile?isLoading:false"
                            :loading-text="$t('table.loading')"
                            :footer-props="{
                                showFirstLastPage: false,
                                itemsPerPageOptions:itemsPerPageOptions,
                                itemsPerPageText: $t('table.itemsPerPage'),
                            }"
                        >
                            <template v-if="!isMobile" #[`group.header`]="{ items, isOpen, toggle }">
                                <th colspan="100%">
                                    <v-icon @click="toggle">{{ isOpen ? 'mdi-minus' : 'mdi-plus' }} </v-icon>

                                    <v-icon :class="getBranchColor(items[0])" class="appbar-icon-button-smaller elevation-1 mr-1 no-background-hover dark-blue-color">
                                        {{ getBranchIcon(items[0]) }}
                                    </v-icon>

                                    {{ items[0].name }}

                                    <!-- If petfood === null, assuming this is a consolidated branch and will display the number as such -->
                                    <span v-if="userStore.hasPermissionTo('View client and branch number')">&nbsp;({{ items[0].is_petfood === null ? items[0].client_number : items[0].branch_identifier }})</span>
                                </th>
                            </template>

                            <template v-if="!isMobile" #[`header.ranking_position`]="scope">
                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                    <template v-slot:activator="{ on, attrs }">
                                        <p v-bind="attrs" v-on="on" class="mb-0 fill-height d-flex align-center justify-center" style="cursor: pointer">{{ scope.header.text }}</p>
                                    </template>

                                    <span v-html="$t('stats.rankingsNote')"></span>
                                </v-tooltip>
                            </template>

                            <template v-if="!isMobile" #[`header.ranking_propec_current_year`]="scope">
                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                    <template v-slot:activator="{ on, attrs }">
                                        <p v-bind="attrs" v-on="on" class="mb-0 fill-height d-flex align-center justify-center" style="cursor: pointer">{{ scope.header.text }}</p>
                                    </template>

                                    <span v-html="$t('stats.rankingsNote')"></span>
                                </v-tooltip>
                            </template>

                            <template v-if="!isMobile" #[`header.ranking_propec_last_year`]="scope">
                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                    <template v-slot:activator="{ on, attrs }">
                                        <p v-bind="attrs" v-on="on" class="mb-0 fill-height d-flex align-center justify-center" style="cursor: pointer">{{ scope.header.text }}</p>
                                    </template>

                                    <span v-html="$t('stats.rankingsNote')"></span>
                                </v-tooltip>
                            </template>

                            <template v-if="!isMobile" #[`item.ranking_position`]="scope">
                                <div v-if="!scope.item.isTotalRow" class="datatable-multi-line-text">
                                    {{ scope.item.ranking_position }}
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.ranking_propec_current_year`]="scope">
                                <div v-if="!scope.item.isTotalRow" class="datatable-multi-line-text">
                                    {{ scope.item.ranking_propec_current_year }}
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.ranking_propec_last_year`]="scope">
                                <div v-if="!scope.item.isTotalRow" class="datatable-multi-line-text">
                                    {{ scope.item.ranking_propec_last_year }}
                                </div>

                                <div v-else><b>{{ tb('Totais:') }}</b></div>
                            </template>

                            <template v-if="!isMobile" #item.sum="scope">
                                <div v-if="scope.item.isTotalRow" class="datatable-multi-line-text">
                                    <b>{{ formatPrice(scope.item.total_sum) }}</b>
                                </div>

                                <div v-else class="datatable-multi-line-text">
                                    {{ formatPrice(scope.item.sum) }}
                                </div>
                            </template>

                            <template v-if="!isMobile" #item.sum_minus_one="scope">
                                <div v-if="scope.item.isTotalRow" class="datatable-multi-line-text">
                                    <b>{{ formatPrice(scope.item.total_sum_minus_one) }}</b>
                                </div>

                                <div v-else class="datatable-multi-line-text">
                                    {{ formatPrice(scope.item.sum_minus_one) }}
                                </div>
                            </template>

                            <template v-if="!isMobile" #item.sum_minus_two="scope">
                                <div v-if="scope.item.isTotalRow" class="datatable-multi-line-text">
                                    <b>{{ formatPrice(scope.item.total_sum_minus_two) }}</b>
                                </div>

                                <div v-else class="datatable-multi-line-text">
                                    {{ formatPrice(scope.item.sum_minus_two) }}
                                </div>
                            </template>
                            <template v-if="isMobile" v-slot:item="{ item, index }">
                                <tr v-if="!item.isTotalRow">
                                    <v-card
                                    elevation="2"
                                    >
                                    <v-row>
                                        <v-col class="d-flex flex-column col pt-0 pb-0">
                                            <v-row class="d-flex align-start pt-0 pb-0">
                                                <v-col class="col col-4 px-0 pt-0 pb-0 wrap-l">
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field field-l-name" >{{ tb('NOME') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field field-l-position" >{{ tb('POSIÇÃO') }} </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-html="'RANKING '+currentYear"></v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-html="'RANKING '+lastYear"></v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" >{{ tb('VALOR') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="item.sum_minus_one">{{ tb('VALOR (N-1)') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="item.sum_minus_two">{{ tb('VALOR (N-2)') }}</v-col>
                                                </v-col>
                                                <v-col class="col col-8  pt-0 pb-0 wrap-r">
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r client-name" >
                                                        <div class="datatable-designation-text ">
                                                            <v-icon :class="getBranchColor(item)" class="appbar-icon-button-smaller elevation-1 mr-1 no-background-hover dark-blue-color">
                                                                    {{ getBranchIcon(item) }}
                                                                </v-icon>

                                                                {{ item.name }}

                                                                <!-- If petfood === null, assuming this is a consolidated branch and will display the number as such -->
                                                                <span v-if="userStore.hasPermissionTo('View client and branch number')">&nbsp;({{ item.is_petfood === null ? item.client_number : item.branch_identifier }})</span>
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r position">
                                                        <div class="datatable-designation-text" >
                                                            {{ item.ranking_position }}
                                                        </div>
                                                    </v-col>

                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            <div class="datatable-multi-line-text">
                                                                {{ item.ranking_propec_current_year }}
                                                            </div>
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            <div  class="datatable-multi-line-text">
                                                                {{ item.ranking_propec_last_year }}
                                                            </div>
                                                        </div>
                                                    </v-col>

                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            <div  class="datatable-multi-line-text">
                                                                {{ formatPrice(item.sum) }}
                                                            </div>
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="item.sum_minus_one">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            <div  class="datatable-multi-line-text">
                                                                {{ formatPrice(item.sum_minus_one) }}
                                                            </div>
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="item.sum_minus_two">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            <div  class="datatable-multi-line-text">
                                                                {{ formatPrice(item.sum_minus_two) }}
                                                            </div>
                                                        </div>
                                                    </v-col>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    </v-card>
                                </tr>
                            </template>

                            <template v-slot:footer="scope">
                                <div>
                                    <div class="datatable-footer-border"></div>

                                    <data-table-footer :showExport="canExport()" @export="exportData" :scope="scope" @updateOptions="refresh" :showOrderButton="false" :isLoading="isLoading" style="height: fit-content"> </data-table-footer>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </pure-datatable>

                <app-card v-if="currentView == 'graph'" class="fill-height px-2" content-style="height: 100%; padding-bottom: 0px">
                    <template v-slot:content-no-margin>
                        <div ref="chartContainer" :style="`height: ${chartContainerSize}px; overflow-y: auto;`" class="top-purchases-chart-container d-flex justify-center">
                            <div class="d-flex align-center justify-space-between">
                                <div class="fill-height">
                                    <div class="d-flex flex-column flex-grow-1 justify-center">
                                        <span class="font-size-lg text-center">{{ $t('stats.top10') }}</span>

                                        <top-purchases-chart toolbar vertical :title="$t('stats.purchaseValue')" :categories="categories" isPriceChart :series="getChartPriceSeries" bar-height="40%" class="top-purchases-column-chart"> </top-purchases-chart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </app-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useAppStore } from '@/Stores/app';
import PureDatatable from '@arentia/atools/PureDatatable';
import { buildQueryObjectFromModel } from '@arentia/atools/QueryBuilder';
import MainLayout from './../../Layouts/MainLayout';
import VFormBase from 'vuetify-form-base';
import moment from 'moment';
import { axios } from '@/Services/Backend';
import ResizeObserver from 'resize-observer-polyfill';

export default {
    layout: MainLayout,

    components: {
        PureDatatable,
        VFormBase,
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
    },

    data: () => ({
        datatableSize: 200,
        chartContainerSize: 200,
        resizeObserver: null,

        filters: {},
        queryParams: {},

        ready: false,
        hasExpandedActiveFilters: false,

        hasN1Active: false,
        hasN2Active: false,

        changeViewTypeEnabled: true,
        currentView: 'table',

        minEndDate: null,
        maxEndDate: null,

        topPurchases: [],
        headers: [],

        chartStatistics: [],
        itemsPerPageOptions:[10,20,50],//window.innerWidth<=1024?[20,50,100]:[10,20,50],
        currentYear:null,
        lastYear:null,
        currentItemDisplay:0,
        first:false
    }),

    created() {
        this.currentYear=new Date().getFullYear()
        this.lastYear= this.currentYear - 1

        if(this.isMobile){
            this.getPrefilledBranches()
        }else{
            this.applyDefaultFilters();
        }

    },

    mounted() {
        this.prepareResponsiveBehaviour();
        if(!this.isMobile){
            this.refresh();
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.makeResponsive);
        this.resizeObserver?.unobserve(this.$refs.headerFilters);
        let portrait = window.matchMedia("(orientation: portrait)");
        portrait.addEventListener("change", (e)=> {
             // Do change
                 this.refreshDeely()
        })
    },

    watch: {
        'branchStore.branch': {
            handler: function (branch) {
                if (!branch) return;

                this.queryParams.branch_id = branch.id;

                this.ready = true;
                if(!this.isMobile){
                    this.refresh();
                }else{
                    if(this.first){
                        this.refresh();
                    }else{
                        this.getPrefilledBranches()
                    }
                }
            },
            immediate: true,
        },
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore,useAppStore),

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .some((x) => (typeof x === 'string' && x !== '') || (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },

        displayItems() {
            if (this.topPurchases.length === 0) {
                return [];
            }

            const total = Object.assign({ isTotalRow: true }, this.topPurchases.at(-1));
            let result = [...this.topPurchases, total]
            this.currentItemDisplay = _.size(result) >0 ? _.size(result)-1: 0
            return [...this.topPurchases, total];
        },

        //
        // Charts
        //
        getChartPriceSeries() {
            const branchSeries = [];

            // Process and add the information from each branch into the branches array
            this.chartStatistics?.forEach((branch) => {
                const data = [branch.sum];
                if (this.hasN1Active) data.push(branch.sum_minus_one);
                if (this.hasN2Active) data.push(branch.sum_minus_two);

                branchSeries.push({
                    name: `${branch.name} ${this.userStore.hasPermissionTo('View client and branch number') ? '(' + branch.branch_identifier + ')' : ''}`,
                    data: data,
                });
            });

            return branchSeries;
        },

        categories() {
            const data = [];
            data.push(this.tb('Período Atual'));
            if (this.hasN1Active) data.push('N - 1');
            if (this.hasN2Active) data.push('N - 2');
            return data;
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        headerProps(){
            return this.appStore.header_props
        }
    },

    methods: {
        getPrefilledBranches(){
             axios
                .get('/api/branches/prefilled-branches')
                .then((response) => {
                       let result = response.data
                       this.model['branches##id']=[];
                       for(let field in result){
                          this.model['branches##id'].push({id:result[field].id})
                       }
                       this.applyDefaultFilters();

                       if(!this.first){
                            this.$nextTick(_=>{
                                this.first=true
                                this.refresh()
                            })
                       }


                }).catch((error) => {
                    console.log(error);
                });
        },
        setItemsPorPage(){
            this.itemsPerPageOptions=[10,20,50]//window.innerWidth<=1024?[20,50,100]:[10,20,50]
        },
        refreshDeely(){
            setTimeout(()=>{
                    this.refresh();
                },300)
        },
        getChartStatistics() {
            const query = buildQueryObjectFromModel(this.filters, this.schema);

            axios
                .post('/api/statistics/top-purchases', {
                    ...this.queryParams,
                    queryObject: JSON.stringify(query),
                    skipPagination: true,
                })
                .then((response) => {
                    response.data.data ? (this.chartStatistics = [...response.data.data]) : (this.chartStatistics = [...response.data]);
                })
                .catch((error) => {
                    this.chartStatistics = [];

                    console.log(error);
                });
        },

        canExport() {
            return this.userStore.hasPermissionTo('Export top purchases');
        },

        exportData() {
            if (!this.branchStore.branch || !this.$refs.datatable) return;

            const axiosSettings = {
                url: '/api/statistics/top-purchases/export',
                params: {
                    branch_id: this.branchStore.branch.id,
                },
            };

            this.$refs.datatable.exportData(axiosSettings, 'export_top_compras');
        },

        changeViewType(type) {
            this.currentView = type == 'graph' ? 'graph' : 'table';
            this.refresh();
        },

        getBranchIcon(branch) {
            switch (branch.is_petfood) {
            case 0:
                return 'mdi-alpha-f';
            case 1:
                return 'mdi-alpha-p';
            default:
                return 'mdi-alpha-c';
            }
        },

        calcColor(value) {
            if (value < 0) {
                return 'red-color';
            }
            if (value > 0) {
                return 'green-color';
            }
        },

        getBranchColor(branch) {
            return branch.is_petfood === 1 ? 'btn-bg-color-navbar-petfood-inactive' : 'btn-bg-color-blue';
        },

        prepareResponsiveBehaviour() {
            this.resizeObserver = new ResizeObserver(this.makeResponsive);
            this.resizeObserver.observe(this.$refs.headerFilters);

            window.addEventListener('resize', this.makeResponsive);

            this.makeResponsive();
        },

        makeResponsive() {
            this.computeDatatableSize();
            this.computeChartContainerSize();
        },

        computeDatatableSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 75 - topHeight;
                this.datatableSize = res;
            }
        },

        computeChartContainerSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 102 - topHeight;
                this.chartContainerSize = res;
            }
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);

            this.onFiltersChanged();
        },
        onFiltersChanged() {
            let hasAutoSearch = this.userStore.user?.auto_search_disabled
            if(this.isIOS()){
                if(!hasAutoSearch){
                    this.setFiltersChanged()
                }
            }else{
                this.setFiltersChanged()
            }
        },
        setFiltersChanged(){
                this.refresh();
                window.EventBus.$emit('check-if-should-overflow');
                window.EventBus.$emit('check-if-should-underflow');
        },

        refresh(options) {
            if (!this.branchStore.branch) return;

            if (this.filters.consolidated == 'Consolidar') {
                this.changeViewTypeEnabled = false;
                this.currentView = 'table';
                this.filters.is_petfood = '';
                this.schema.is_petfood.disabled = true;
            } else {
                this.changeViewTypeEnabled = true;
                this.schema.is_petfood.disabled = false;
            }

            if (this.currentView == 'graph') {
                delete this.filters.consolidated;
            }

            // Check if the start_date and end_date filters are valid (must be within a 1 year interval, will use start_date as the basis for all checks)
            if (this.filters.start_date != null) {
                // Set the limit end date to 1 year starting from the start_date
                this.minEndDate = this.filters.start_date;
                this.maxEndDate = moment(this.filters.start_date).add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD');
                this.schema.end_date.minDate = this.minEndDate;
                this.schema.end_date.maxDate = this.maxEndDate;

                // If the other date is set and somehow exceeds the 1 year maximum gap, we'll adjust it accordingly
                if (this.filters.end_date) {
                    // if end date is set and is lower than start date, set a new end date 1 year from the start date
                    const minEndDate = moment(this.filters.start_date).format('YYYY-MM-DD');
                    if (moment(this.filters.end_date) < moment(minEndDate)) this.filters.end_date = moment(this.filters.start_date).add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD');

                    // If end date is set and is higher than 1 year after the start date, set it to 1 year from the start date
                    const maxEndDate = moment(this.filters.start_date).add(1, 'year').subtract(1, 'day').format('YYYY-MM-DD');
                    if (moment(this.filters.end_date) > moment(maxEndDate)) this.filters.end_date = maxEndDate;
                }
            } else {
                // Clear the limit end date
                this.minEndDate = null;
                this.maxEndDate = null;
                this.schema.end_date.minDate = null;
                this.schema.end_date.maxDate = null;
            }

            this.hasN1Active = this.filters?.homologous_period__id?.find((el) => el.id == 1) ? true : false;
            this.hasN2Active = this.filters?.homologous_period__id?.find((el) => el.id == 2) ? true : false;

            const query = this.filters;

            if (this.$refs.datatable) {
                if (options) {
                    this.$refs.datatable.setLocalOptions(options);
                }else{
                        options=this.$refs.datatable.localOptions
                        options.itemsPerPage=window.innerWidth>=768&&window.innerWidth<=1366?20:10
                        this.$refs.datatable.setLocalOptions(options);
                }

                if (this.currentView == 'table') {
                    this.$refs.datatable.onChangeQueryBuilder(query, this.schema);
                }
            }

            if (this.currentView == 'graph') {
                this.getChartStatistics();
            }

            this.calcHeaders();
        },

        calcHeaders() {
            let paddingWidth = 0;

            if (!this.userStore.hasPermissionTo('Top purchases overall rankings')) paddingWidth += 20;
            if (!this.hasN1Active) paddingWidth += 20;
            if (!this.hasN2Active) paddingWidth += 20;

            const headers = [];
            if (paddingWidth > 0) {
                headers.push({
                    text: '',
                    align: 'center',
                    sortable: false,
                    value: '',
                    width: paddingWidth + '%',
                });
            }

            headers.push({
                text: 'Posição',
                align: 'center',
                sortable: false,
                value: 'ranking_position',
                width: '10%',
            });
            if (this.userStore.hasPermissionTo('Top purchases overall rankings')) {
                headers.push(
                    {
                        text: this.$t('stats.ranking', { year: moment().format('YYYY') }),
                        align: 'center',
                        sortable: false,
                        value: 'ranking_propec_current_year',
                        width: '10%',
                    },
                    {
                        text: this.$t('stats.ranking', { year: moment().subtract(1, 'year').format('YYYY') }),
                        align: 'center',
                        sortable: false,
                        value: 'ranking_propec_last_year',
                        width: '10%',
                    }
                );
            }
            headers.push({
                text: 'Valor',
                align: 'center',
                sortable: false,
                value: 'sum',
                width: '10%',
            });
            if (this.hasN1Active) {
                headers.push({
                    text: 'Valor N-1',
                    align: 'center',
                    sortable: false,
                    value: 'sum_minus_one',
                    width: '10%',
                });
            }
            if (this.hasN2Active) {
                headers.push({
                    text: 'Valor N-2',
                    align: 'center',
                    sortable: false,
                    value: 'sum_minus_two',
                    width: '10%',
                });
            }

            this.headers = headers;
        },

        onDataChanges(value) {
            // Update local data so that we can later display the total sum.
            this.$set(this, 'topPurchases', value?.data ?? []);

            const wrapper = this.$refs['datatable']?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },

        applyDefaultFilters() {
            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }
        },

        onClearFilters() {
            this.applyDefaultFilters();
            this.hasExpandedActiveFilters = false;

            this.refresh();
        },
    },
};
</script>

<style>
.max-pagination-height > .v-pagination {
    height: 24px !important;
}
.max-pagination-height > .v-pagination .v-pagination__item {
    font-size: 12px !important;
}

.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}

#form-base > div > .v-input > .v-input__control > .v-input__slot .v-input__icon--prepend-inner button.v-icon {
    color: #154579;
    font-size: 18px !important;
}
</style>

<style scoped>
.statistics-card-title {
    font-size: 0.65rem !important;
    width: 83px;
}
.statistics-card-subtitle {
    font-size: 0.65rem !important;

    width: 97px;
}
.statistics-card {
    height: 120px;
    width: 180px;
}
.statistics-title {
    font-size: 1rem !important;
}
.top-purchases-column-chart {
    height: 280px;
    width: 700px;
}
@media only screen and (min-width: 1300px) {
    .top-purchases-column-chart {
        height: 350px;
        width: 700px;
    }
}

@media only screen and (min-width: 1600px) {
    .statistics-card-title {
        font-size: 0.75rem !important;
    }
    .statistics-card-subtitle {
        font-size: 0.75rem !important;
    }
    .statistics-card {
        height: 125px;
        width: 200px;
    }

    .top-purchases-column-chart {
        height: 350px;
        width: 1000px;
    }

    .top-purchases-chart-container {
        padding-top: 16px;
    }
}
</style>
